import React from "react";

import { Box, SkeletonText, SkeletonCircle } from "@/storybook-components";

interface ICard {
  count?: number;
}

const CardSkeleton = ({ count = 3 }: ICard) => {
  const skeletons = [];

  for (let i = 0; i < count; i++) {
    skeletons.push(
      <Box key={i} padding="6" bg="gray.100">
        <SkeletonCircle size="10" />
        <SkeletonText mt="4" noOfLines={4} spacing="4" skeletonHeight="2" />
      </Box>
    );
  }

  return <>{skeletons}</>;
};

export default CardSkeleton;
